import _availableReports from "@/assets/json/availableReports.json";
import { useAppUserStore } from "@/stores/app-user";

export interface Report {
  name: string;
  title: string;
  description: string;
  permission: string;
  canBeScheduled: boolean;
  availableFormats: string[];
  availableFilters: {
    key: string;
    label: string;
    options: {
      [k: string]: {
        operator: string;
        label: string;
        field?: string;
        options?: { key: string; label: string }[] | string[];
      };
    };
  }[];
}

export const getAvailableReports = (): Report[] => {
  const userStore = useAppUserStore();
  const reportsConfig = _availableReports as Report[];
  const availableReports: Report[] = [];

  for (const report of reportsConfig) {
    // Report permissions use the partnerPortal:runReport* prefix — NOT covered
    // by getLocationsForPermission's dashboard-only wildcard fallback. Fall back
    // to partnerPortal:* here so wildcard org-admins see all six reports; the
    // IAM :* wildcard semantically grants every partnerPortal action.
    const permissionIds =
      userStore.permissions?.[report.permission] ??
      userStore.permissions?.["partnerPortal:*"] ??
      [];
    // Gate availability on *resolvable* locations — not just permission-array
    // length — so stale sessions with unresolvable IDs don't surface a report
    // with an empty location dropdown.
    const resolvedLocations = permissionIds
      .map((id) => userStore.getLocation(id))
      .filter((loc): loc is NonNullable<typeof loc> => !!loc);

    if (resolvedLocations.length === 0) continue;

    report.availableFilters = report.availableFilters.map((filter) => {
      if (filter.key === "locationId") {
        filter.options.equals.options = resolvedLocations
          .map((location): { key: string; label: string } => ({
            key: location.locationId,
            label: location.name,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));
      }

      return filter;
    });

    availableReports.push(report);
  }

  return availableReports;
};
